module.exports = function () {
    var $ = require('jquery');
	var show_search_body = false;

$(function() {

    var results_view = function( action ) {
        if('show' === action) {
            $('#main-content').show();
            $('#algolia-stats').show();
            $('.page-dynamic-content').hide();
            show_search_body = true;
        } else if('hide' === action) {
            $('#main-content').hide();
            $('.page-dynamic-content').show();
        }
    };

	if($('.page-template-page-vendor-directory-landing #algolia-search-box').length > 0) {

		if (algolia.indices.posts_vendor === undefined && $('.admin-bar').length > 0) {
			alert('It looks like you haven\'t indexed the searchable posts index. Please head to the Indexing page of the Algolia Search plugin and index it.');
		}

		/* Instantiate instantsearch.js */
		var search = instantsearch({
			indexName: algolia.indices.posts_vendor.name,
			searchClient: algoliasearch( algolia.application_id, algolia.search_api_key ),
			routing: {
				router: instantsearch.routers.history({ writeDelay: 1000 }),
				stateMapping: {
					stateToRoute( indexUiState ) {
						return {
							s: indexUiState[ algolia.indices.posts_vendor.name ].query,
							page: indexUiState[ algolia.indices.posts_vendor.name ].page
						}
					},
					routeToState( routeState ) {
						const indexUiState = {};
						indexUiState[ algolia.indices.posts_vendor.name ] = {
							query: routeState.s,
							page: routeState.page
						};
						return indexUiState;
					}
				}
			},
			searchFunction: function (helper) {
                if (helper.state.query === '' && !show_search_body) {
                    helper.search();
                    results_view('hide');
                    return;
                }
                helper.search();
                results_view('show');
            }
		});

		var $body = $('body');
		$body.on('change', '#facet-vertical select', function (e) {
			if (!show_search_body && '__EMPTY__' !== this.value) {
				results_view('show');
			}
		});

		// Reuse
		const noResultsTemplate = `
		<div class="col-xs-12">
			<div class="no-results">
			Sorry, we didn't find any results for "<span class="bold">{{query}}</span>"
				<div class="col-xs-12 heading">Tips:</div>
				<div class="col-xs-12">
					<ul>
						<li>Double-check your spelling</li>
						<li>Try searching for a term that is less specific</li>
						<li>Use different keywords</li>
					</ul>
					<div class="col-xs-12 col-lg-6 text-center">
						<a href="javascript:void(0);" class="btn outline ais-clear-all--link">Clear Search</a>
					</div>
				</div>
			</div>
		</div>
		`

		const itemMarkup = `
					<a class="{{cssClasses.link}}" href="{{url}}">
						<span class="{{cssClasses.label}}">{{label}}</span>
						<span class="{{cssClasses.count}}">
						({{#helpers.formatNumber}}{{count}}{{/helpers.formatNumber}})
						</span>
					</a>
					`

		search.addWidgets([

			/* Search box widget */
			instantsearch.widgets.searchBox({
				container: '#algolia-search-box',
				placeholder: 'Search...',
				showReset: true,
				showSubmit: false,
				showLoadingIndicator: false,
				wrapInput: false,
				cssClasses: {
					resetIcon: [
						'ais-clear-all--link'
					]
				  }
			}),

			/* Reset Refinements */
			instantsearch.widgets.clearRefinements({
				container: '#clear-refinements',
				templates: {
					resetLabel: 'Clear Selections',
				},
				cssClasses: {
					root: 'clearSelections',
					button: [
					  'cta load-more-button',
					],
				  },
			}),

			/* Stats widget */
			instantsearch.widgets.stats({
				container: '#algolia-stats',
				autoHideContainer: true
			}),

			/* Hits widget */
			instantsearch.widgets.hits({
				container: '#algolia-hits',
				hitsPerPage: 20,
				templates: {
					empty: noResultsTemplate,
					item: wp.template('instantsearch-hit')
				}
			}),

			/* Pagination widget */
			instantsearch.widgets.pagination({
				container: '#algolia-pagination'
			}),

			/* Facet: Genre */
			instantsearch.widgets.menu({
				container: '#facet-expertise',
				attribute: 'taxonomies.expertise',
				sortBy: ['isRefined:desc', 'count:desc', 'name:asc'],
				limit: 50,
				templates: {
					item: itemMarkup
				}
			}),

			/* Facet: Industry */
			instantsearch.widgets.menu({
				container: '#facet-industry',
				attribute: 'taxonomies.industry',
				sortBy: ['isRefined:desc', 'count:desc', 'name:asc'],
				limit: 50,
				templates: {
					item: itemMarkup
				}
			}),
			
			/* Facet: Verticals */
			instantsearch.widgets.menuSelect({
				container: '#facet-vertical',
				attribute: 'taxonomies.products-services',
				sortBy: ['name:asc','count:desc'],
				limit: 50,
				templates: {
					item: itemMarkup
				}
			}),

		]);

		/* Start */
		search.start();

		$( '#algolia-search-box input' ).attr( 'type', 'search' ).trigger( 'select' );

		let toggles = document.querySelectorAll('[data-facet-toggle]')

		function toggleFacet(e){
			e.preventDefault();
			if(this.querySelector('.ais-body')){
			this.classList.toggle('active');
			}
		}

		toggles.forEach(function(el){
			el.addEventListener('click', toggleFacet);
		});
	}
});
};